import * as React from "react";
import { NativeAdContainerRegionProps } from "./typings";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { NativeAd } from "components/utility/Ads/NativeAd";
import { logger } from "bernie-core";
/**
 * Native Ad Container Region wraps its children and first attempts to make a request for an ad based on the uci defined in Flex manager.
 * The children components of the region will be serve as the fallback of the of the Ad component, logic to show the fallback or ad is contained
 * in the NativeAd component (see link below).
 * @see https://github.expedia.biz/Flex/blossom-flex-ui/blob/master/src/components/utility/Ads/NativeAd.tsx
 * @see https://pages.github.expedia.biz/Flex/blossom-flex-ui-documentation/docs/Domains_within_Blossom/Storefront_BEX_+_COMET/Native_Ad_Container/
 * @see https://github.expedia.biz/MediaSolutions/ads-delivery-service/wiki
 */
export const NativeAdContainerRegionComponent = (props: NativeAdContainerRegionProps) => {
  const blossomComponent = BlossomComponentFactory.get(props as BlossomComponentFactoryProps);
  const { context, flexComponent } = props;

  if (!flexComponent || !flexComponent.model || !blossomComponent) {
    return null;
  }

  const children = blossomComponent.renderChildren(props.logger, props.l10n, context);
  const uci = flexComponent.model.uci;

  return (
    <div className="NativeAdContainerRegion NativeCardPadding" id={`native-ad-${uci}`}>
      <NativeAd uci={uci} type="native-ad" className="all-t-padding-three">
        {children}
      </NativeAd>
    </div>
  );
};

export const NativeAdContainerRegion = logger("NativeAdContainerRegion")(NativeAdContainerRegionComponent);

export default NativeAdContainerRegion;
